// Filtros da Consulta NFe: núcleo da "Pesquisa Importação" do FLOW (PO1-2967)
// mais divergência e vínculo com CT-e da Consulta NFe antiga, unificadas em
// 31/10/2026. Definição para a URL (utils/filtrosUrl) e opções dos selects.
// Sem React.
import { filtrosAtivos } from "../../../utils/filtrosUrl";
import { chaveCompleta, chaveParcial } from "../../../utils/periodoPesquisa";
import { UFS, UF_OPTIONS } from "../../../constants/ufs";

export const TETO_DIAS = 365;
export const PAGE_SIZES = [25, 50, 100];

export const ORDENACAO = ["emissao", "importacao", "numero", "transportadora", "valorNota", "freteSimulado"];

// PO1-3856: UFS e UF_OPTIONS moram em constants/ufs; reexportadas aqui para quem já importa deste módulo.
export { UFS, UF_OPTIONS };

export const DEFINICAO_FILTROS = {
  tipoData: { padrao: "emissao", tipo: "enum", opcoes: ["emissao", "importacao"] },
  dataInicial: { padrao: "", tipo: "texto" },
  dataFinal: { padrao: "", tipo: "texto" },
  chave: { padrao: "", tipo: "texto" },
  numero: { padrao: "", tipo: "texto" },
  serie: { padrao: "", tipo: "texto" },
  pedido: { padrao: "", tipo: "texto" },
  transportadoraId: { padrao: null, tipo: "inteiro", min: 1 },
  destinatario: { padrao: "", tipo: "texto" },
  cnpjTomador: { padrao: "", tipo: "texto" },
  statusCalculo: { padrao: "", tipo: "enum", opcoes: ["0", "1", "2", "3", "4", "5"] },
  tipoOperacao: { padrao: "", tipo: "enum", opcoes: ["0", "1"] },
  modalidadeFrete: { padrao: "", tipo: "enum", opcoes: ["0", "1", "2", "3", "4", "9"] },
  situacaoId: { padrao: "", tipo: "enum", opcoes: ["1", "2", "3", "4", "5", "6"] },
  ufDestino: { padrao: "", tipo: "enum", opcoes: UFS },
  cidadeDestinoId: { padrao: null, tipo: "inteiro", min: 1 },
  numeroCte: { padrao: "", tipo: "texto" },
  modalId: { padrao: null, tipo: "inteiro", min: 1 },
  negocioId: { padrao: null, tipo: "inteiro", min: 1 },
  tipoServicoId: { padrao: null, tipo: "inteiro", min: 1 },
  divergencia: { padrao: "", tipo: "enum", opcoes: ["sim", "nao"] },
  comCte: { padrao: "", tipo: "enum", opcoes: ["sim", "nao"] },
  pagina: { padrao: 1, tipo: "inteiro", min: 1 },
  tamanhoPagina: { padrao: 25, tipo: "inteiro", min: 10, max: 100 },
  ordenarPor: { padrao: "emissao", tipo: "enum", opcoes: ORDENACAO },
  ordem: { padrao: "desc", tipo: "enum", opcoes: ["asc", "desc"] },
};

export const CHAVES_AVANCADAS = [
  "chave", "numero", "serie", "pedido", "transportadoraId", "destinatario", "cnpjTomador", "statusCalculo", "tipoOperacao",
  "modalidadeFrete", "situacaoId", "ufDestino", "cidadeDestinoId", "numeroCte", "modalId", "negocioId", "tipoServicoId",
  "divergencia", "comCte",
];

export const TIPO_DATA_OPTIONS = [
  { value: "emissao", label: "Emissão" },
  { value: "importacao", label: "Importação" },
];

// Rótulos da Consulta NFe do Hub (os mesmos do backend, pesquisa-documentos/
// helpers/rotulos.js): no Hub o 3 é o cálculo normal e o 2 é "sem tabela"; o 5
// é a nota de frota própria (PO1-3447). O 1 quase não aparece, fica no fim.
export const STATUS_CALCULO_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "0", label: "Pendente" },
  { value: "2", label: "Não calculado" },
  { value: "3", label: "Calculado" },
  { value: "4", label: "Recalcular" },
  { value: "5", label: "Frota própria (sem cálculo)" },
  { value: "1", label: "Calculado (frete e prazo)" },
];

export const DIVERGENCIA_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "sim", label: "Com divergência" },
  { value: "nao", label: "Sem divergência" },
];

export const COM_CTE_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "sim", label: "Com CT-e" },
  { value: "nao", label: "Sem CT-e" },
];

export const TIPO_OPERACAO_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "0", label: "Entrada" },
  { value: "1", label: "Saída" },
];

export const MODALIDADE_FRETE_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "0", label: "Por conta da empresa (CIF)" },
  { value: "1", label: "Por conta do destinatário/remetente (FOB)" },
  { value: "2", label: "Por conta de terceiros" },
  { value: "3", label: "Transporte próprio por conta da empresa" },
  { value: "4", label: "Transporte próprio por conta do destinatário/remetente" },
  { value: "9", label: "Sem ocorrência de transporte" },
];

export const SITUACAO_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "1", label: "Aguardando CT-e" },
  { value: "2", label: "A Faturar" },
  { value: "3", label: "Em Faturamento" },
  { value: "4", label: "Faturado" },
  { value: "5", label: "Cancelada" },
  { value: "6", label: "Frota própria" },
];

export const STATUS_TONE = { 0: "warning", 1: "success", 2: "neutral", 3: "success", 4: "info", 5: "neutral" };

// Busca direta (período ignorado) só com a chave completa ou o número; trecho
// de chave segue o período com teto de 31 dias (PO1-3904, igual à API).
export const buscaDireta = (f) => Boolean(chaveCompleta(f.chave) || (f.numero || "").trim());
export const comChaveParcial = (f) => !buscaDireta(f) && Boolean(chaveParcial(f.chave));

export function paramsDaApi(filtros, { embarcadorId, transportadoraId } = {}, { paraExportar = false } = {}) {
  const ativos = filtrosAtivos(filtros, DEFINICAO_FILTROS);
  const params = {
    ...ativos,
    ordenarPor: filtros.ordenarPor || DEFINICAO_FILTROS.ordenarPor.padrao,
    ordem: filtros.ordem || DEFINICAO_FILTROS.ordem.padrao,
  };
  if (paraExportar) {
    delete params.pagina;
    delete params.tamanhoPagina;
  } else {
    params.pagina = filtros.pagina || 1;
    params.tamanhoPagina = filtros.tamanhoPagina || DEFINICAO_FILTROS.tamanhoPagina.padrao;
  }
  if (embarcadorId) params.embarcadorId = embarcadorId;
  if (transportadoraId) params.transportadoraId = transportadoraId;
  return params;
}
